.redo-icon {
  display: block;
  margin: auto;
}
